export default "__VITE_ASSET__uMIk7z7u__"